import { Component } from '@angular/core';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-self-service-portal',
  imports: [FeatureHero],
  templateUrl: './self-service-portal.html',
  styleUrl: './self-service-portal.scss',
})
export class SelfServicePortal {

}
